import { createNamespacedHelpers } from 'vuex-composition-helpers/dist';

export default function () {
  const { useActions, useState } = createNamespacedHelpers('company');
  const { company, vacancies } = useState(['company', 'vacancies']);
  const { fetchCompany, fetchCompanyById } = useActions(['fetchCompany', 'fetchCompanyById']);
  return {
    company,
    fetchCompany,
    fetchCompanyById,
  };
}
